<template>
    <div class="no-padding no-margin">
        <div v-if="path.includes(`/provider-advisor/providers/${routeParams}/providers`)" class="">
            <ProvidersTable v-if="path == `/provider-advisor/providers/${routeParams}/providers`"></ProvidersTable>
            <ResultTable v-if="path == `/provider-advisor/providers/${routeParams}/providers/result`"></ResultTable>
            <AddProviders v-if="path == `/provider-advisor/providers/${routeParams}/providers/add-providers` "></AddProviders>
            <InviteProvider v-if="path == `/provider-advisor/providers/${routeParams}/providers/invite-providers`"></InviteProvider>
            <ProviderCrudForm v-if="path == `/provider-advisor/providers/${routeParams}/providers/provider`"></ProviderCrudForm>
            <SingleNpi v-if="path == `/provider-advisor/providers/${routeParams}/providers/result/npi` "></SingleNpi>
        </div>
        <div v-else-if="path.includes(`/provider-advisor/providers/${routeParams}/affiliates`)">
            <ProvidersTable v-if="path == `/provider-advisor/providers/${routeParams}/affiliates`"></ProvidersTable>
            <ResultTable v-if="path == `/provider-advisor/providers/${routeParams}/affiliates/result`"></ResultTable>
            <AddProviders v-if="path == `/provider-advisor/providers/${routeParams}/affiliates/add-providers` "></AddProviders>
            <InviteProvider v-if="path == `/provider-advisor/providers/${routeParams}/affiliates/invite-providers`"></InviteProvider>
            <ProviderCrudForm v-if="path == `/provider-advisor/providers/${routeParams}/affiliates/provider`"></ProviderCrudForm>
            <SingleNpi v-if="path == `/provider-advisor/providers/${routeParams}/affiliates/result/npi` "></SingleNpi>
        </div>
         <div  v-else>
            <ProvidersTable v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based`"></ProvidersTable>
            <ResultTable v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based/result`"></ResultTable>
            <AddProviders v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based/add-providers` "></AddProviders>
            <InviteProvider v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based/invite-providers`"></InviteProvider>
            <ProviderCrudForm v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based/provider`"></ProviderCrudForm>
            <SingleNpi v-if="path == `/provider-advisor/providers/${routeParams}/hospital-based/result/npi` "></SingleNpi>
        </div>

      
    </div>
</template>
<script>
import AddProviders from './AddProviders.vue'
import InviteProvider from './InviteProvider.vue'
import ProviderCrudForm from './ProviderCrudForm.vue'
import ResultTable from './ResultTable.vue'
import ProvidersTable from './ProvidersTable.vue'
import SingleNpi from './SingleNpi.vue'



export default {
    components:{
    ResultTable,
    AddProviders,
    InviteProvider,
    ProviderCrudForm,
    ProvidersTable,
    SingleNpi,


    },
    data(){
        return{
            
        }
    },
    computed:{
        path(){
             return this.$route.path.replace(/%20/g,' ')
        },
        routeName(){
            return this.$route.params.name
        },
         routeParams(){
            return this.$route.params.name
      }
    },
   
    created(){
      
    },
    methods:{
     
    }
   
}
</script>
<style>
.background-opacity{
    opacity: 0.46;
    background-color: rgb(33, 33, 33);
    border-color: rgb(33, 33, 33);
}
</style>